import { appNames, isAgentMetrics, runningApp } from '../../constants/app';
import { environments, getEnvironment } from './environment';
import { ACCOUNTS, INTERNAL_EMAIL_DOMAIN } from '../../constants';

export const ENVIROS_WHERE_TREND_ANALYSIS_IS_HIDDEN = [
    environments.PRD,
];

export const ENVIROS_WHERE_CONNECT_MLS_IS_HIDDEN = [
    environments.PRD,
    environments.PRE,
];

export const getIsTrendAnalysisDebugEnabled = (hostname, envirosWhereTrendAnalysisIsHidden) => {
    const currentEnvironment = getEnvironment(hostname);
    return !envirosWhereTrendAnalysisIsHidden?.find(enviro => enviro === currentEnvironment);
};

export const getIsInternalEmailAddress = (email = '') => email?.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN.toLowerCase());

export const getIsConnectMlsEnabled = ({ isAgentMetrics, email, hostname, envirosWhereIsHidden }) => {
    if (!isAgentMetrics) return false;

    if (!hostname) return false;
    const currentEnviro = getEnvironment(hostname);
    if (envirosWhereIsHidden?.find(enviro => enviro === currentEnviro)) return false;

    if (getIsInternalEmailAddress(email)) return false;

    return true;
};

export const getIsComparisonSetsEnabled = () => runningApp !== appNames.XAM;

export const isComparisonSetsEnabled = getIsComparisonSetsEnabled();

export const getIsInternalAccount = accountId => accountId === ACCOUNTS.LONE_WOLF_INTERNAL.id;

export const getIsAgentMetricsInternalUser = email => isAgentMetrics && email.endsWith(INTERNAL_EMAIL_DOMAIN);

export const getIsNotificationsEnabled = (isAgentMetrics) => !isAgentMetrics;

export const getIsDashboardEnabled = isAgentMetrics => {
    return !isAgentMetrics;
};

export const pdfUnderConstructionModules = [];

export const pdfDisabledRoutes = [];

export const IS_TALENT_LINK_ENABLED = true;
